/*
 * @Author: XuXin 2172438065@qq.com
 * @Date: 2024-06-21 08:35:01
 * @LastEditors: XuXin 2172438065@qq.com
 * @LastEditTime: 2025-01-06 09:29:37
 * @FilePath: \high-tech-materialsd:\workCode\xx\youbi\front\CustPC\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import './plugins/element'
import './plugins/clipboard'
import 'font-awesome/css/font-awesome.min.css'

Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
